<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="leads" :searchlink="route('internal.lead.search',branchid)" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Lead')">
<!--                <template #action="data">-->
<!--                    <button-link :href="route('internal.enquiry.edit',[branchid,data.item.id])" >View</button-link>-->
<!--                </template>-->

            </breeze-table>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Internal,
            BreezeTable,
            ButtonLink
        },
        props:['leads'],
        data(){
            return{
                fields:[{'key':'formatted_created_at','label':'Date'},{'key':'full_name','label':'Name'},{'key':'email','label':'Email'},{'key':'mobile','label':'Mobile'},{'key':'course','label':'Course'},{'key':'source','label':'Source'}],
                branchid:localStorage.branchId
            }
        }
    }
</script>
